import { Component, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from "../auth.service";
import { OnInit } from '@angular/core';

@Component({
  selector: 'app-internal-login',
  templateUrl: './internal-login.component.html',
  styleUrls: ['./internal-login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InternalLoginComponent implements OnInit, AfterViewInit {
  public form: FormGroup;
  public errorMessage: string;

  public isLoading = false;

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.form = this.fb.group({
    });
  }

  ngOnInit() {
    if (this.authService.isAuthenticated) {
      this.authService.navigateToLandingPage();
    }
  }

  ngAfterViewInit() {
    document.getElementById('preloader').classList.add('hide');
  }

  public async login() {
    try {
      this.errorMessage = '';
      this.isLoading = true;

      await this.authService.loginWithMsalAccessToken();
    } catch(err) {
    }
  }

  onSwitchToExternalLogin() {
    this.authService.setIsInternalUserLogin(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/internal-login/internal-login.component.ts